/* eslint-disable no-undef */
/* eslint-disable yoda */
import React, { useState, useEffect } from 'react';

import { Dialog, DialogContent } from '@ps-design-system/components/Dialog';

import PauseModalStepOne from './PauseModalStepOne';
import PauseModalStepTwo from './PauseModalStepTwo';
import PauseModalStepThree from './PauseModalStepThree';

import { usePauseModal } from '../context/PauseModalContext';
import { usePauseListingActions } from '../hooks/usePauseListingActions';
import { fetchListingInfo } from '../../../../app-main/actions/listing';
import { REASONS } from '../constants/pause.consts';

const STEPS = {
  ONE: 'step-one',
  TWO: 'step-two',
  THREE: 'step-three'
};

const PauseModal = () => {
  const [currentStep, setCurrentStep] = useState(STEPS.ONE);
  const [reason, setReason] = useState('');
  const [other, setOther] = useState('');
  const [applyToAllListingsToggle, setApplyToAllListingsToggle] = useState(false);
  const {
    openPause,
    setPauseOpen,
    closePauseModal,
    spaceID,
    listingID,
    listingsIDs,
    dispatch,
    SSOid
  } = usePauseModal();
  const { handlePauseListing, handlePauseListings } = usePauseListingActions();

  useEffect(() => {
    if (reason !== 'other') {
      setOther('');
    }
  }, [reason]);

  const resetState = () => {
    setCurrentStep(STEPS.ONE);
    setReason('');
    setOther('');
    setApplyToAllListingsToggle(false);
  };

  const handleCancel = () => {
    resetState();
    closePauseModal();
  };

  const handleOpenChange = (isOpen) => {
    setPauseOpen(isOpen);

    if (!isOpen) {
      resetState();
    }
  };

  const handleSubmit = async () => {
    let idsToTrack = [];
    try {
      if (applyToAllListingsToggle) {
        await handlePauseListings(spaceID);
        idsToTrack = [...listingsIDs];
      } else {
        await handlePauseListing(listingID);
        idsToTrack.push(listingID);
      }
      analytics.track('listing paused', {
        ssoId: SSOid,
        listingIds: idsToTrack,
        reason: reason,
        otherText: other
      });
    } catch (error) {
      // silently fail
    } finally {
      dispatch(fetchListingInfo(listingID));
    }
    resetState();
    closePauseModal();
  };

  const renderStep = () => {
    switch (currentStep) {
    case STEPS.ONE:
      return (
        <PauseModalStepOne
          onNextStep={() => setCurrentStep(STEPS.TWO)}
          applyToAllListingsToggle={applyToAllListingsToggle}
          setApplyToAllListingsToggle={setApplyToAllListingsToggle}
        />
      );
    case STEPS.TWO:
      return (
        <PauseModalStepTwo
          reason={reason}
          setReason={setReason}
          other={other}
          setOther={setOther}
          onNextStep={() => setCurrentStep(STEPS.THREE)}
          onCancel={handleCancel}
        />
      );
    case STEPS.THREE:
      return (
        <PauseModalStepThree
          reason={REASONS[reason]}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          applyToAllListingsToggle={applyToAllListingsToggle}
          setApplyToAllListingsToggle={setApplyToAllListingsToggle}
        />
      );
    default:
      return null;
    }
  };

  return (
    <Dialog open={openPause} onOpenChange={handleOpenChange} >
      <DialogContent size="lg">
        {renderStep()}
      </DialogContent>
    </Dialog>
  );
};

export default PauseModal;
